import config from '@/config';
import useCache from '@/hooks/useCache';
import useStateHandler from '@/hooks/useStateHandler';
import useTranslations from '@/i18n/useTranslations';
import SettingsLoadingPage from '@/shared-components/loaders/components/SettingsLoadingPage';
import SettingsHeading from '@/shared-components/text/components/SettingsHeading';
import Text from '@/shared-components/text/components/Text';

import RepresentativeForm from './components/RepresentativeForm';

import './index.css';

export default function GalleryInformation() {
  const { state } = useStateHandler();
  const t = useTranslations('common.user_settings.gallery_information');
  const contactSuffix = t('contact.suffix');
  const { loading, fetchData, setFetchData } = useCache(`${state.user_session._id}_gallery_information`, `${config.apis.api.url}/gallery/info`, {
    injectToken: true
  });

  function onEditGalleryAgent(newGalleryAgent) {
    setFetchData({
      ...fetchData,
      gallery_agent: newGalleryAgent
    });
  }

  if(loading) {
    return (
      <SettingsLoadingPage page={t('heading')}/>
    );
  } else {
    return (
      <>
        <SettingsHeading text={t('heading')}/>
        <div className="settings-gallery-information__container">
          <Text className="settings-gallery-information__heading">
            {t('heading')}
          </Text>
    
          <Text
            className="settings-gallery-information__static-text"
            paragraph>
            {t('business_id_label')} <span>{fetchData.gallery_business_id}</span>
          </Text>
    
          <Text
            className="settings-gallery-information__static-text"
            paragraph>
            {t('location_label')}{' '}
            <span>
              {
                `${fetchData.gallery_address.street}
                                (${fetchData.gallery_address.city}, 
                                ${fetchData.gallery_address.region}, 
                                ${fetchData.gallery_address.country})`
              }
            </span>
          </Text>
    
          <Text
            className="settings-gallery-information__contact-us-text"
            paragraph>
            {t('contact.prefix')}
            {' '}
            <a className="settings-contact-us-link" href="mailto:galleries@suarte.art">{t('contact.email')}</a>
            {contactSuffix !== 'contact.suffix' ? contactSuffix : ''}
          </Text>
    
          <Text className="settings-gallery-information__heading">
            {t('representative_heading')}
          </Text>
    
          <RepresentativeForm fetchData={fetchData} onEditGalleryAgent={onEditGalleryAgent}/>
        </div>
      </>
    );
  }
}
